export const fetchJson = <T>(url: string, init?: RequestInit): Promise<T> =>
	fetch(url, { credentials: 'include', ...init }).then((response) => {
		if (response.ok) {
			return response.json();
		}
		throw new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`);
	});
